<template>
    <v-card class="topic-container">
        <topic-data
            :topics="topics"
        />
    </v-card>
</template>

<script>
import TopicData from './components/TopicData'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const RoleRepository = RepositoryFactory.get('role')
export default {
    components: { TopicData },
    data() {
        return {
            totalItem: 0,
            topics: [],
            filterForm: {}
        }
    },

    created() {
        this.getList()

        Bus.$on('search-topic-list', () => {
            this.getList()
        })
    },

    beforeDestroy() {
        Bus.$off('search-topic-list')
    },

    methods: {
        async getList() {
            const loading = this.$loading.show()
            const res = await RoleRepository.listTopic() 
            loading.hide()

            if (res.success) {
                this.topics = _.get(res, 'data', [])
                this.totalItem = _.get(res, 'totalItem', 0)
            } else {
                this.topics = []
                this.totalItem = 0
            }
        }
    }
}
</script>

<style scoped>
.topic-container {
    background-color: white;
    margin: 0px 20px;
    padding: 10px;
}
</style>
